// システムメンテナンス
export class ServiceUnavailable extends Error {
  static readonly CODE = 'SYS_ERR_SERVICE_UNAVAILABLE';

  readonly code: string;

  constructor(message: string) {
    super(message);
    this.name = 'ServiceUnavailable';
    this.code = ServiceUnavailable.CODE;
  }
}

// 要ログイン
export class LoginRequired extends Error {
  static readonly CODE = 'APP_ERR_LOGIN_REQUIRED';

  readonly code: string;

  constructor(message: string) {
    super(message);
    this.name = 'LoginRequired';
    this.code = LoginRequired.CODE;
  }
}

// 無効ユーザー(activated=False)
export class UserNotActivated extends Error {
  static readonly CODE = 'APP_ERR_USER_NOT_ACTIVATED';

  readonly code: string;

  constructor(message: string) {
    super(message);
    this.name = 'UserNotActivated';
    this.code = UserNotActivated.CODE;
  }
}

// ユーザー情報がない
export class UserNotFound extends Error {
  static readonly CODE = 'APP_ERR_USER_NOT_FOUND';

  readonly code: string;

  constructor(message: string) {
    super(message);
    this.name = 'UserNotFound';
    this.code = UserNotFound.CODE;
  }
}

// 退会エラー（有効なサブスクリプションが存在）
export class UserTerminateErrorHasActiveSubscriptions extends Error {
  static readonly CODE = 'APP_ERR_USER_NOT_TERMINATE_001';

  readonly code: string;

  constructor(message: string) {
    super(message);
    this.name = 'UserTerminateErrorHasActiveSubscriptions';
    this.code = UserTerminateErrorHasActiveSubscriptions.CODE;
  }
}

// チームが存在しない
export class TeamNotFound extends Error {
  static readonly CODE = 'APP_ERR_TEAM_001';

  readonly code: string;

  constructor(message: string) {
    super(message);
    this.name = 'TeamNotFound';
    this.code = TeamNotFound.CODE;
  }
}

// チームサブスクリプション切れ
export class TeamSubscriptionExpired extends Error {
  static readonly CODE = 'APP_ERR_TEAM_002';

  readonly code: string;

  constructor(message: string) {
    super(message);
    this.name = 'TeamSubscriptionExpired';
    this.code = TeamSubscriptionExpired.CODE;
  }
}

// チーム所属なし
export class UnassignedTeamException extends Error {
  static readonly CODE = 'APP_ERR_TEAM_003';

  readonly code: string;

  constructor(message: string) {
    super(message);
    this.name = 'UnassignedTeamException';
    this.code = UnassignedTeamException.CODE;
  }
}

// 決済機能停止中
export class PaymenteSystemStopped extends Error {
  static readonly CODE = 'APP_PAYMENT_SYSTEM_STOPPED';

  readonly code: string;

  constructor(message: string) {
    super(message);
    this.name = 'PaymenteSystemStopped';
    this.code = PaymenteSystemStopped.CODE;
  }
}

// 課金機能アクセスエラー
export class PaidAccessError extends Error {
  static readonly CODE = 'APP_ERR_PAID_ACCESS';

  readonly code: string;

  constructor(message: string) {
    super(message);
    this.name = 'PaidAccessError';
    this.code = PaidAccessError.CODE;
  }
}

// チケット有効期限切れ
export class TicketExpired extends Error {
  static readonly CODE = 'APP_ERR_TICKET_001';

  readonly code: string;

  constructor(message: string) {
    super(message);
    this.name = 'TicketExpired';
    this.code = TicketExpired.CODE;
  }
}

// チケット適用中
export class TicketStillValidException extends Error {
  static readonly CODE = 'APP_ERR_TICKET_002';

  readonly code: string;

  constructor(message: string) {
    super(message);
    this.name = 'TicketStillValid';
    this.code = TicketStillValidException.CODE;
  }
}

// 決済システム（Stripe）エラー
export class PaymentSystemError extends Error {
  static readonly CODE = 'APP_ERR_TICKET_003';

  readonly code: string;

  constructor(message: string) {
    super(message);
    this.name = 'PaymentSystemError';
    this.code = PaymentSystemError.CODE;
  }
}

// チーム作成上限
export class TeamCreationLimited extends Error {
  static readonly CODE = 'APP_ERR_TEAM_001';

  readonly code: string;

  constructor(message: string) {
    super(message);
    this.name = 'TeamCreationLimited';
    this.code = TeamCreationLimited.CODE;
  }
}
